export const QueryParamConstants = {
  intent: 'i',
  hereAndNow: {
    explore: {
      search: 'q',
      buildingId: 'buildingId',
      resourceId: 'r',
    },
  },
} as const;
